import {
  createResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'marketing-tools/'

const LAST_VIEWED_PRODUCT_SLIDER_URL = prefixAPI('last-view-product/list-html/', MODEL)
const RECOMMENDED_PRODUCT_SLIDER_URL = prefixAPI('recommended-product/list-html/', MODEL)

export const lastViewedProductSliderResource = createResource(LAST_VIEWED_PRODUCT_SLIDER_URL)
export const recommendedProductSliderResource = createResource(RECOMMENDED_PRODUCT_SLIDER_URL)
